export const breakpoints = {
  LargeDesktopWidth: 1900,
  MiddleDesktopWidth: 1600,
  DesktopWidth: 1280,
  MdDesktopWidth: 1200,
  SmDesktopWidth: 992,
  TabletWidth: 768,
  PhoneWidth: 576,
  LPhoneWidth: 428,
  MPhoneWidth: 375,
  SmPhoneWidth: 320,

  xsMax: 768,
  mdMin: 769,
  mdMedium: 1200,
  mdMax: 1600,
  lgMin: 1601,
  lgMedium: 1700,
  lgMax: 2500,
  xlMin: 2501,
  xlMaxFake: 8000,
};

export const colors = {
  white: '#ffffff',
  backgroundBlack: '#16161B',
  black: '#1B1B22',
  blackDark: '#000000',
  grey: '#24242C',
  greyAlt: '#23232A',
  greyLight: '#737389',
  greyLightAlt: '#7C7C8C',
  greayLightAlt2: '#A2A3A4',
  baseBackgroundDark: '#131313',
  basePersonaBackgroundDark: '#242627',

  yellow: '#F3CE7B',
  blue: '#4E81F3',
  green: '#339B62',
  greenLight: '#339B6250',
  redLight: '#E7605650',
  yellowLight: '#f3ce7b70',

  //other colors
  red: '#E76056',
  activeRed: '#FF3333',
  blueDark: '#586DE4',
  blueLight: '#6BABFF',
  basePersonaBackgroundLight: '#E9EDF0',
  linePrimaryLight: '#0000001F',
  linePrimaryDark: '#FFFFFF1F',
  lineActiveDark: '#2E7CF6',
  textHinitLight: '#0000004D',
  textHinitDark: '#FFFFFF4D',
  textPrimaryLight: '#000000D9',
  textPrimaryDark: '#FFFFFFD9',
  baseAccentDisabledLight: '#0000000F',
  baseAccentDisabledDark: '#FFFFFF0F',
  lineHoverLight: '#00000033',
  lineHoverDark: '#FFFFFF33',
  lineErrorLight: 'rgba(229, 50, 77, 0.8)',
  lineErrorDark: 'rgba(229, 50, 93, 0.8)',

  purpleGrey: '#E3D9EA',
};

export const fontSizes = {
  fontOldMainSize: 14,
  fontYoungMainSize: 18,
};

export const header = {
  heightHeader: 75,
  heightMenu: 65,
  heightHeaderFull: 75 + 65,
  heightMobileHeader: 60,
  heightMobileMenu: 50,
  heightMobileHeaderFull: 60 + 50,
};

export const footer = {
  heightFooter: 140,
  heightDesktopFooter: 290,
  heightMobileFooter: 190,
};

export const paddings = {
  DesktopContainerPadding: 80,
  SmDesktopContainerPadding: 30,
  MobileContainerPadding: 10,
};
